import getJSONP, { HOST, BASE_URL } from './request';
import { getPlatform } from '@utiles/index';

const PLATFORM = getPlatform();
const ajaxUrl = {
  getArticleDetail: {
    global: `${BASE_URL}/website/getWebsiteArticleByGroupId`,
    gm99: ``,
  },
  searchArticle: {
    global: `${BASE_URL}/website/getWebsiteArticle`,
    gm99: ``,
  },
  getArticleList: {
    global: `${BASE_URL}/website/getWebsiteContent`,
    gm99: ``,
  },
  getSiteSwiper: {
    global: `${BASE_URL}/website/getWebsiteSlice`,
    gm99: ``,
  },
  getSiteTag: {
    global: `${BASE_URL}/website/getWebsiteTag`,
    gm99: ``,
  },
};

export const getArticleDetail = function (data) {
  return getJSONP(ajaxUrl.getArticleDetail[PLATFORM], data);
};

export const searchArticle = function (data) {
  return getJSONP(ajaxUrl.searchArticle[PLATFORM], data);
};

export const getArticleList = function (data) {
  return getJSONP(ajaxUrl.getArticleList[PLATFORM], data);
};

export const getSiteSwiper = function (data) {
  return getJSONP(ajaxUrl.getSiteSwiper[PLATFORM], data);
};

export const getSiteTag = function (data) {
  return getJSONP(ajaxUrl.getSiteTag[PLATFORM], data);
};
